/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/1152g05j/screen/67851869
 */

import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import clone from 'ramda/src/clone';
import split from 'ramda/src/split';
import takeLast from 'ramda/src/takeLast';
import Button from '@components/@core/AnimatedButton';
import Icon from '@components/@core/Icon';
import Thumbnail from '@components/@core/Thumbnail';
import ProductRating from './ProductRating';
import AppActions from '~/actions/app';
import { convertUrl, hasHtml, isImageURL } from '~/services/util';

const DEFAULTVIDEOS = [
    '/images/profile/products/0.png',
    '/images/profile/products/1.png',
    '/images/profile/products/2.png',
    '/images/profile/products/3.png',
    '/images/profile/products/4.png',
    '/images/profile/products/5.png',
];

const ReactPlayer = loadable(() => import('react-player'), { ssr: false });

const PremiumShow = ({ data, title }) => {
    const dispatch = useDispatch();

    const medias = data?.media ?? [];

    const _videos = Array.isArray(data?.data?.videos) ? (data?.data?.videos ?? []) : [];
    const videos = clone(_videos);
    DEFAULTVIDEOS.forEach((item, index) => {
        if (!videos[index]) videos[index] = item;
    });

    const documents = data?.documents ?? [];
    const name = documents[0]?.data?.document_url ? takeLast(1, split('/', documents[0]?.data?.document_url)) : 'our CRM whitepaper';

    const specialname = documents[1]?.data?.document_url ? takeLast(1, split('/', documents[1]?.data?.document_url)) : 'our CRM whitepaper';

    const handlePreviewMedia = (idx) => () => {
        dispatch(AppActions.modalRequest({ type: 'Premium Media View', data: { before: { videos, medias, selected: idx } } }));
    };

    return (
        <>
            <div className="d-flex align-items-end mb-4">
                <span className="dsl-b24 bold">{title}</span>
            </div>
            <div className="d-flex video-section mb-4 pb-3 flex-md-row flex-column">
                <div className={`d-flex-1 me-md-1 video-card ${medias[0] ? '' : videos[0] && isImageURL(videos[0]) ? '' : 'video'}`} onClick={handlePreviewMedia(0)}>
                    {videos[0] ? (
                        <>{isImageURL(videos[0]) ? <Thumbnail source={convertUrl(videos[0])} size="responsive" /> : <ReactPlayer url={videos[0]} width="100%" height="100%" />}</>
                    ) : (
                        <Thumbnail source={medias[0]?.data?.file_path ?? '/images/profile/products/0.png'} size="responsive" />
                    )}
                    {(videos[0] || medias[0]) && (
                        <div className="controls d-h-center">
                            {videos[0] ? (
                                <Icon name={`${isImageURL(videos[0]) ? 'fas fa-search' : 'far fa-play-circle'}`} size={40} color="#376caf" />
                            ) : (
                                <Icon name="fas fa-search" size={40} color="#376caf" />
                            )}
                        </div>
                    )}
                </div>
                <div className={`d-flex-1 mx-md-1 video-card ${medias[1] ? '' : videos[1] && isImageURL(videos[1]) ? '' : 'video'}`} onClick={handlePreviewMedia(1)}>
                    {videos[1] ? (
                        <>{isImageURL(videos[1]) ? <Thumbnail source={convertUrl(videos[1])} size="responsive" /> : <ReactPlayer url={videos[1]} width="100%" height="100%" />}</>
                    ) : (
                        <Thumbnail source={medias[1]?.data?.file_path ?? '/images/profile/products/1.png'} size="responsive" />
                    )}
                    {(videos[1] || medias[1]) && (
                        <div className="controls d-h-center">
                            {videos[1] ? (
                                <Icon name={`${isImageURL(videos[1]) ? 'fas fa-search' : 'far fa-play-circle'}`} size={40} color="#376caf" />
                            ) : (
                                <Icon name="fas fa-search" size={40} color="#376caf" />
                            )}
                        </div>
                    )}
                </div>
                <div className="d-flex d-flex-1 ms-md-1">
                    <div className="d-flex d-flex-1 flex-column justify-content-between me-1">
                        {videos[2] || medias[2] ? (
                            <div className={`video-card mb-1 small ${medias[2] ? '' : videos[2] && isImageURL(videos[2]) ? '' : 'video'}`} onClick={handlePreviewMedia(2)}>
                                {videos[2] ? (
                                    <>
                                        {isImageURL(videos[2]) ? (
                                            <Thumbnail source={convertUrl(videos[2])} size="responsive" />
                                        ) : (
                                            <ReactPlayer className="mb-1" url={videos[2]} width="100%" height="100%" />
                                        )}
                                    </>
                                ) : (
                                    medias[2]?.data?.file_path && <Thumbnail source={medias[2]?.data?.file_path} size="responsive" />
                                )}
                                <div className="controls d-h-center">
                                    {videos[2] ? (
                                        <Icon name={`${isImageURL(videos[2]) ? 'fas fa-search' : 'far fa-play-circle'}`} size={40} color="#376caf" />
                                    ) : (
                                        <Icon name="fas fa-search" size={40} color="#376caf" />
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className="video-card mb-1 small">
                                <Thumbnail source="/images/profile/products/2.png" size="responsive" />
                            </div>
                        )}
                        {videos[3] || medias[3] ? (
                            <div className={`video-card mt-1 small ${medias[3] ? '' : videos[3] && isImageURL(videos[3]) ? '' : 'video'}`} onClick={handlePreviewMedia(3)}>
                                {videos[3] ? (
                                    <>
                                        {isImageURL(videos[3]) ? (
                                            <Thumbnail source={convertUrl(videos[3])} size="responsive" />
                                        ) : (
                                            <ReactPlayer className="mt-1" url={videos[3]} width="100%" height="100%" />
                                        )}
                                    </>
                                ) : (
                                    medias[3]?.data?.file_path && <Thumbnail source={medias[3]?.data?.file_path} size="responsive" />
                                )}
                                <div className="controls d-h-center">
                                    {videos[3] ? (
                                        <Icon name={`${isImageURL(videos[3]) ? 'fas fa-search' : 'far fa-play-circle'}`} size={40} color="#376caf" />
                                    ) : (
                                        <Icon name="fas fa-search" size={40} color="#376caf" />
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className="video-card mt-1 small">
                                <Thumbnail source="/images/profile/products/3.png" size="responsive" />
                            </div>
                        )}
                    </div>
                    <div className="d-flex d-flex-1 flex-column justify-content-between ms-1">
                        {videos[4] || medias[4] ? (
                            <div className={`video-card mb-1 small ${medias[4] ? '' : videos[4] && isImageURL(videos[4]) ? '' : 'video'}`} onClick={handlePreviewMedia(4)}>
                                {videos[4] ? (
                                    <>
                                        {isImageURL(videos[4]) ? (
                                            <Thumbnail source={convertUrl(videos[4])} size="responsive" />
                                        ) : (
                                            <ReactPlayer className="mb-1" url={videos[4]} width="100%" height="100%" />
                                        )}
                                    </>
                                ) : (
                                    medias[4]?.data?.file_path && <Thumbnail source={medias[4]?.data?.file_path} size="responsive" />
                                )}
                                <div className="controls d-h-center">
                                    {videos[4] ? (
                                        <Icon name={`${isImageURL(videos[4]) ? 'fas fa-search' : 'far fa-play-circle'}`} size={40} color="#376caf" />
                                    ) : (
                                        <Icon name="fas fa-search" size={40} color="#376caf" />
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className="video-card mb-1 small">
                                <Thumbnail source="/images/profile/products/4.png" size="responsive" />
                            </div>
                        )}
                        {videos[5] || medias[5] ? (
                            <div className={`video-card mt-1 small ${medias[5] ? '' : videos[5] && isImageURL(videos[5]) ? '' : 'video'}`} onClick={handlePreviewMedia(5)}>
                                {videos[5] ? (
                                    <>
                                        {isImageURL(videos[5]) ? (
                                            <Thumbnail source={convertUrl(videos[5])} size="responsive" />
                                        ) : (
                                            <ReactPlayer className="mt-1" url={videos[5]} width="100%" height="100%" />
                                        )}
                                    </>
                                ) : (
                                    <Thumbnail source={medias[5]?.data?.file_path} size="responsive" />
                                )}
                                <div className="controls d-h-center">
                                    {videos[5] ? (
                                        <Icon name={`${isImageURL(videos[5]) ? 'fas fa-search' : 'far fa-play-circle'}`} size={40} color="#376caf" />
                                    ) : (
                                        <Icon name="fas fa-search" size={40} color="#376caf" />
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className="video-card mt-1 small">
                                <Thumbnail source="/images/profile/products/5.png" size="responsive" />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="d-flex flex-md-row flex-column">
                <div className="d-flex-2 me-md-5 mb-5 mb-md-0">
                    <ProductRating className="pb-4 me-4 border-bottom" data={data} />
                    <p className="dsl-b18 bold mt-4">Contact</p>
                    <div className="contact mt-4">
                        <Icon name="fas fa-phone-alt head" color="dark" size={14} />
                        {data.data?.contact?.phone ? (
                            <a className="dsl-b16 info" href={`tel:${data.data?.contact?.phone}`}>
                                {data.data?.contact?.phone}
                            </a>
                        ) : (
                            <span className="dsl-b16">Not provided</span>
                        )}
                    </div>
                    <div className="contact mt-4">
                        <Icon name="fas fa-window-maximize head" color="dark" size={14} />
                        {data.data?.website ? (
                            <a className="dsl-b16 info" href={data.data?.website} target="_blank">
                                {data.data?.website}
                            </a>
                        ) : (
                            <span className="dsl-b16">Not provided</span>
                        )}
                    </div>
                    <div className="contact mt-4">
                        <Icon name="fas fa-envelope head" color="dark" size={14} />
                        {data.data?.contact?.email ? (
                            <a className="dsl-b16 info" href={`mailto:${data.data?.contact?.email}`}>
                                {data.data?.contact?.email}
                            </a>
                        ) : (
                            <span className="dsl-b16">Not provided</span>
                        )}
                    </div>
                </div>
                <div className="d-flex-5">
                    <div className="about-section-wrapper">
                        <p className="dsl-b18 bold">About</p>
                        {hasHtml(data.data?.description ?? '') ? (
                            <div className="about-section" dangerouslySetInnerHTML={{ __html: data.data.description }} />
                        ) : (
                            <div className="about-section">
                                <p className="dsl-b16">{data.data?.description}</p>
                            </div>
                        )}
                    </div>
                    <p className="dsl-b18 bold mt-4">Offers</p>
                    <div className="d-flex align-items-center">
                        <div className="d-flex-1 align-items-center">
                            <div className="d-flex mb-3">
                                <Icon name="fas fa-newspaper mx-auto" color="#376caf" size={24} />
                            </div>
                            {documents[0]?.data?.document_url ? (
                                <>
                                    <p className="dsl-b14 text-center">{`Download ${name}.pdf`}</p>
                                    <div className="d-flex mb-3">
                                        <Button className="mx-auto" type="medium">
                                            <a className="dsl-b14" href={documents[0]?.data?.document_url || null} target="_blank">
                                                Download
                                            </a>
                                        </Button>
                                    </div>
                                </>
                            ) : (
                                <p className="dsl-b14 text-center">No Whitepapers To Download</p>
                            )}
                        </div>
                        <div className="d-flex-1">
                            <div className="d-flex mb-3">
                                <Icon name="fas fa-newspaper mx-auto" color="#376caf" size={24} />
                            </div>
                            {documents[1]?.data?.document_url ? (
                                <>
                                    <p className="dsl-b14 text-center">{`Download ${specialname}.pdf`}</p>
                                    <div className="d-flex mb-3">
                                        <Button className="mx-auto" type="medium">
                                            <a className="dsl-b14" href={documents[1]?.data?.document_url || null} target="_blank">
                                                SPECIAL OFFER
                                            </a>
                                        </Button>
                                    </div>
                                </>
                            ) : (
                                <p className="dsl-b14 text-center">No Special Offer To Download</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

PremiumShow.propTypes = {
    data: PropTypes.any,
    title: PropTypes.string,
};

PremiumShow.defaultProps = {
    data: {},
    title: 'HCM',
};

export default PremiumShow;
